import { render, staticRenderFns } from "./IconTables.vue?vue&type=template&id=3cc51875&"
import script from "./IconTables.vue?vue&type=script&lang=js&"
export * from "./IconTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports